import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Download, FileText } from "lucide-react";
import { LOGO_URL, PORTRAIT_URL } from "@/lib/assets";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const NARRATIVE_BIO_PDF = `${BACKEND}/api/files/judge-auntie/uploads/b5b415f9b1ce4a898f41b8ceb6b28c05.pdf`;

export default function Press() {
  const [assets, setAssets] = useState([]);
  useEffect(() => { api.get("/press").then(r => setAssets(r.data)); }, []);
  return (
    <div className="bg-cream">
      <div className="brand-container py-20">
        <div className="brand-eyebrow">Press Kit</div>
        <h1 className="brand-h1 mt-3">For editors, producers,<br/>and event organizers.</h1>
        <p className="brand-lede mt-6 max-w-2xl">Download official photos, biographical text, and speaker one-sheets. For interview requests, email <a href="mailto:press@judgeauntiesays.com" className="text-plum underline">press@judgeauntiesays.com</a>.</p>

        <div className="mt-14 grid md:grid-cols-2 gap-6">
          <div className="editorial-card p-6 flex gap-6 items-center">
            <img src={LOGO_URL} alt="Wordmark" className="w-40 h-40 object-contain rounded" />
            <div>
              <div className="brand-eyebrow">Wordmark</div>
              <h3 className="font-serif text-xl mt-2">Judge Auntie™ logo (gold)</h3>
              <a href={LOGO_URL} download className="btn-outline mt-4 inline-flex" data-testid="press-download-logo"><Download className="w-4 h-4" /> Download</a>
            </div>
          </div>
          <div className="editorial-card p-6 flex gap-6 items-center">
            <img src={PORTRAIT_URL} alt="Portrait" className="w-40 h-40 object-cover rounded" />
            <div>
              <div className="brand-eyebrow">Portrait</div>
              <h3 className="font-serif text-xl mt-2">Judicial robe portrait</h3>
              <a href={PORTRAIT_URL} download className="btn-outline mt-4 inline-flex" data-testid="press-download-portrait"><Download className="w-4 h-4" /> Download</a>
            </div>
          </div>
          <div className="editorial-card p-6 flex gap-6 items-center md:col-span-2">
            <div className="w-40 h-40 flex-shrink-0 rounded border border-gold-light bg-cream-alt flex items-center justify-center">
              <FileText className="w-16 h-16 text-plum" strokeWidth={1.2} />
            </div>
            <div>
              <div className="brand-eyebrow">Narrative Biography</div>
              <h3 className="font-serif text-xl mt-2">Full narrative bio — program version (PDF)</h3>
              <p className="text-sm text-charcoal/60 mt-2">Judge Olds' complete narrative bio formatted for programs, keynotes, and media kits.</p>
              <a href={NARRATIVE_BIO_PDF} download="Judge-Eileen-Olds-Narrative-Bio.pdf" className="btn-primary mt-4 inline-flex text-xs" data-testid="press-download-bio-pdf"><Download className="w-4 h-4" /> Download Narrative Bio (PDF)</a>
            </div>
          </div>
        </div>

        <h2 className="brand-h2 mt-20 mb-8">Additional press assets</h2>
        <div className="grid md:grid-cols-3 gap-6">
          {assets.map((a) => (
            <div key={a.id} className="editorial-card p-6">
              <div className="brand-eyebrow">{a.kind}</div>
              <h4 className="font-serif text-lg mt-2">{a.title}</h4>
              {a.description && <p className="text-sm text-charcoal/60 mt-2">{a.description}</p>}
              {a.file_url ? (
                <a href={a.file_url} download className="btn-outline mt-4 inline-flex text-xs" data-testid={`press-asset-${a.id}`}><Download className="w-4 h-4" /> Download</a>
              ) : (
                <span className="text-xs text-charcoal/40 mt-4 inline-block">Coming soon</span>
              )}
            </div>
          ))}
        </div>

        <section className="mt-20 editorial-card p-10">
          <div className="brand-eyebrow">Approved Biography</div>
          <h3 className="brand-h3 mt-3">Short bio (~120 words)</h3>
          <p className="brand-body mt-4">
            The Honorable Eileen A. Olds (Ret.) served for more than two decades on the bench in Chesapeake, Virginia,
            with primary experience in family and juvenile court. Known for rulings that paired judicial rigor with genuine
            humanity, Judge Olds now brings her voice to a wider audience through Judge Auntie Says — a membership home
            for reflections, live sessions, and speaking engagements. A courtyard park in Chesapeake bears her name in
            recognition of decades of service to the community. She speaks nationally on judicial integrity, family systems,
            women's leadership, and the quiet authority of chosen elders.
          </p>
        </section>
      </div>
    </div>
  );
}
